export const isObjectEmpty = (object: Object): boolean | null => {
  try {
    return Object.keys(object).length === 0;
  } catch (error) {
    console.error(error);
    return null
  }
}